import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-type" }

import { type PropType } from 'vue';

import type { MarketModel } from '@exchange/libs/market/service/src';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

import OrderDisplayType from './OrderDisplayType.vue';
import OrderStopPrice from './OrderStopPrice.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderType',
  props: {
  market: { type: Object as PropType<MarketModel> },
  mobile: { type: Boolean, default: false },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.mobile)
      ? (_openBlock(), _createBlock(OrderDisplayType, {
          key: 0,
          class: "label",
          order: __props.order,
          variant: "short"
        }, null, 8, ["order"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(OrderDisplayType, {
            class: "type__long",
            order: __props.order,
            variant: "long"
          }, null, 8, ["order"]),
          _createVNode(OrderDisplayType, {
            class: "type__short",
            order: __props.order,
            variant: "short"
          }, null, 8, ["order"])
        ], 64)),
    (__props.order.isStopOrder)
      ? (_openBlock(), _createBlock(OrderStopPrice, {
          key: 2,
          class: "order-type__stop-price",
          "with-prefix": true,
          order: __props.order,
          market: __props.market
        }, null, 8, ["order", "market"]))
      : _createCommentVNode("", true)
  ]))
}
}

})